export const routeStorageRules = [
  {
    key: "companiesTable",
    isInScope: (path: string) => path.startsWith("/companies"),
  },
  {
    key: "brandsTable",
    isInScope: (path: string) => {
      if (path.startsWith("/company-settings")) return true;

      return /^\/companies\/\d+/.test(path);
    },
  },
  {
    key: "briefsTable",
    isInScope: (path: string) => path.startsWith("/creator-briefs"),
  },
];
